// extracted by mini-css-extract-plugin
export default {"root":"app-core-components-BoxSelector-BoxSelector-module__root"};